import {Album} from '../interfaces/entities/album.interface';

export function isXmasAlbumId(id: Album['id'], year?: number) {
  return !year ? id.match(/^xmas-\d{4}-.+$/) : id.match(new RegExp(`^xmas-${year}-.+$`));
}
